module.exports = __webpack_public_path__ + "assets/img/10.6747ff0a.png";